import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules } from '@utils';

import { globalActions, userActions, useStore } from '@modules';
import { PhoneFormatsType } from '@modules/global/types';

import Button from '@components/Button';
import CountrySelect from '@components/CountrySelect';
import Restriction from '@components/Restriction';
import LoaderLayout from '@layouts/LoaderLayout';

import style from './SetCountry.scss';

const cn = bemCssModules(style, 'SetCountry');

export const SetCountry: CustomFC = ({ className }) => {
  const { t } = useTranslation();
  const [{ global, user }, dispatch] = useStore();
  const { errors, loaders } = user;
  const { countries } = global;
  const [countryCode, setCountryCode] = useState<PhoneFormatsType>(CONST.defaultCountryCode);
  const error = errors.data?.country_code?.[0];
  const isLoading = !!loaders.editUser;

  useEffect(() => {
    dispatch(globalActions.getDataByIp())
      .unwrap()
      .then(res => {
        setCountryCode(res.data.country.code);
      })
      .catch(err => err);
  }, []);

  const handleSubmit = () => {
    dispatch(userActions.editUser({ country_code: countryCode }))
      .unwrap()
      .then(() => {
        dispatch(userActions.setIsCountry(false));
      });
  };

  const handleSelectCountry = (code: PhoneFormatsType) => {
    setCountryCode(code);
  };

  const isSubmitDisabled = !countryCode;

  return (
    <Restriction
      className={cn(null, [className])}
      classNameLayout={cn('wrapper')}
      title={t('public.set_country.header')}
      button={
        <Button
          className={cn('button')}
          disabled={isSubmitDisabled}
          onClick={handleSubmit}
          isLoading={isLoading}
        >
          {t('public.set_country.button')}
        </Button>
      }
    >
      <LoaderLayout isLoading={global.loaders.getDataByIp}>
        <CountrySelect
          countries={countries}
          value={countryCode}
          onSelectCountry={handleSelectCountry}
          placeholder={t('public.set_country.placeholder')}
          param="title"
          className={cn('country-select')}
          classNameButton={cn('country-value')}
        />
        {error && <div className={cn('error')}>{error}</div>}
      </LoaderLayout>
    </Restriction>
  );
};

export default SetCountry;
